// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"f021597d","58":"fcc4fcbe","245":"7ac4dbaa","260":"891bce7d","401":"f4089339","456":"0d9a26d8","483":"50fdb1b9","589":"1f86ab73","855":"06dd092b","886":"6b30dcfa"}[chunkId] + ".chunk.js";
};